import { InMemoryDbService } from 'angular-in-memory-web-api';
import { AndonGroup } from './andon-group';
import { AndonNotice, AndonNoticeSum } from './andon-notice';
// import { AndonNoticeSum } from './andon-notice-sum';
import { AndonCauseCode } from './andon-cause-code';

export class InMemoryDataService implements InMemoryDbService {
  createDb() {
    const andonCauseCode: AndonCauseCode[] = [
      { causeCode: '1', andonID: 1, content: 'センサー異常検知', andonColor: 'Alert' },
      { causeCode: '1', andonID: 1, content: 'センサー異常かも', andonColor: 'Warn' }
    ];
    const andonGroup: AndonGroup[] = [
      { andonGroupID: 1, andonGroupName: '顧客設備' },
      { andonGroupID: 2, andonGroupName: '在庫管理' },
      { andonGroupID: 3, andonGroupName: 'コール' },
      { andonGroupID: 9, andonGroupName: 'サービスリードタイム' },
      { andonGroupID: 15, andonGroupName: 'デモ' }
    ];
    const andonNotice: AndonNotice[] = [
      { andonNoticeID: 612, andonID: 1, andonName: '熊本工場 Coater Developer',
        title: 'エンドユーザー:DEMOテクノロジーズ熊本工場\n設備:CoaterDeveloper[EU0101-Z0001] 異常',
        causeCode: '1', content: 'センサー異常検知', andonColor: 'Info',
        message: '設備 CoaterDeveloper [EU0101-Z0001] にてセンサーデータの異常を検知しました。\r\n詳細を確認してください。\r\nエンドユーザー:DEMOテクノロジーズ熊本工場\r\n設備:CoaterDeveloper[EU0101-Z0001]\r\nユニット:SpinCoatUnit\r\nライン:H1\r\nフロア:F1\r\n異常検知センサー:加速度\r\n異常内容:設備の振動が閾値上限値をオーバーしました。至急、設備の状態を確認してください。',
        attachment: '', noticeAuthor: 'System', noticeAuthorName: '', noticeUpdater: '', noticeUpdaterName: '',
        lastModifyDate: new Date, delayFlg: true }
     ];
    const andonNoticeSum: AndonNoticeSum[] = [
      { andonGroupID: 1, andonID: 3, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '阿蘇工場 Coater Developer',
      infoQty: 0, warnQty: 0, alertQty: 1, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 1, andonID: 4, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '八代工場 Coater Developer',
      infoQty: 0, warnQty: 1, alertQty: 0, noResolutionQty: 0, delayFlg: true, groupSort: 0, andonSort: 0 },
      { andonGroupID: 0, andonID: 5, andonGroupName: '', andonName: 'さいたま工場 PowerUnit',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 1, andonID: 1, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '熊本工場 Coater Developer',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 1, andonID: 13, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '熊本工場 PowerUnit',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 1, andonID: 14, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '阿蘇工場 PowerUnit',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 2, andonID: 15, andonGroupName: '顧客設備（DEMOテクノロジーズ）', andonName: '八代工場 PowerUnit',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: false, groupSort: 0, andonSort: 0 },
      { andonGroupID: 2, andonID: 2, andonGroupName: '在庫管理', andonName: '安全在庫',
      infoQty: 0, warnQty: 0, alertQty: 0, noResolutionQty: 0, delayFlg: true, groupSort: 0, andonSort: 0 },
    ];
    return {andonCauseCode, andonGroup, andonNotice, andonNoticeSum};
  }
}
